import { render } from "./TestGrade.vue?vue&type=template&id=54d48cee&scoped=true"
import script from "./TestGrade.vue?vue&type=script&lang=js"
export * from "./TestGrade.vue?vue&type=script&lang=js"

import "./TestGrade.vue?vue&type=style&index=0&id=54d48cee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d48cee"]])

export default __exports__